import { Grid } from '@mantine/core';
import type { UseFormReturn } from 'react-hook-form';
import type { FormNames } from '../../../../../../react-commons/utils/form/getFormNames';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import {
    SystemUserGroupPropertyValidation,
    type SystemUserGroupResource,
} from '../../../../resource/resources/persistables/user/systemUserGroupResource';
import { ArrayInputs } from '../../../reusable-components/base/property-bases/ArrayInputs';
import { PropertyInputs } from '../../../reusable-components/base/property-bases/PropertyInputs';

export const SystemUserGroupUsersTabContent = ({
    form,
    formNames,
    id,
}: {
    form: UseFormReturn<SystemUserGroupResource>;
    formNames: FormNames<SystemUserGroupResource>;
    id: string | undefined;
}) => {
    return (
        <Grid>
            <Grid.Col span={12}>
                <ArrayInputs.SystemUserGroup_Array
                    form={form}
                    readOnly={false}
                    name={formNames.systemUserGroups}
                    label={'System User Groups Assigned'}
                />
            </Grid.Col>
            <Grid.Col span={12}>
                <ArrayInputs.User_Array form={form} readOnly={false} name={formNames.users} label={'Users Assigned'} />
            </Grid.Col>
            <Grid.Col span={12}>
                <PropertyInputs.String
                    nullable={true}
                    control={form.control}
                    name={formNames.userWildcardMatcher}
                    readOnly={false}
                    propertyValidationInformation={{
                        resourceId: id,
                        resourceType: ResourceType.SYSTEM_USER_GROUP,
                        propertyIdentifier: SystemUserGroupPropertyValidation.USER_WILDCARD_MATCHER,
                    }}
                />
            </Grid.Col>
        </Grid>
    );
};
